const allNewsItem = document.querySelectorAll('.card.news');
const numberShowMore = 10;

function showMore(e) {
	e.preventDefault();

	let counter = 1;

	for (let i = 0; i < allNewsItem.length; i++) {
		if (getComputedStyle(allNewsItem[i]).display === 'none') {
			allNewsItem[i].style.display = 'block';
			counter++;

			if (i + 1 === allNewsItem.length) {
				this.style.display = 'none';
			}

			if (counter > numberShowMore) {
				break;
			}
		}
	}
}

function init() {
	const contentResult = document.querySelector('.contents-page__result');
	if (contentResult) {
		const btnShowMoreNews = contentResult.querySelector('.card--show-more');
		if (contentResult.querySelector('.card.news') && btnShowMoreNews) {
			btnShowMoreNews.onclick = showMore;
		}
	}
}

export default {
	init,
	showMore,
};
